import { useSelector } from "react-redux";

const selectSidePanelCenterMap = (state) =>state.ui.sidePanel.centerMap

export function useSidePanelCenterMap() {
    return useSelector(selectSidePanelCenterMap);
}